import React from 'react';

export default function DemographicLibraryModal() {
  return <div />;
}
